import { render } from "./RecepcionInputComponent.vue?vue&type=template&id=7f6a438d&scoped=true"
import script from "./RecepcionInputComponent.vue?vue&type=script&lang=js"
export * from "./RecepcionInputComponent.vue?vue&type=script&lang=js"

import "./RecepcionInputComponent.vue?vue&type=style&index=0&id=7f6a438d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6a438d"]])

export default __exports__